 import styled from "styled-components";
import { TextInput, } from "@components";
import { getPercChange, } from "./helpers";
import { useSharedDraftable, } from "@bracket/platform/hooks";

import {
	Button,
	Loader,
	Tooltip,
	Typography,
} from "@bracket/ui";


import {
	useVaults,
} from "@store";

import type { FunctionComponent, } from "react";




export const VanityCard: FunctionComponent = () => {

	const {
		ready,
		activeAdminVault: vault,
		updateVanityNav,
	} = useVaults();

	if(!ready || !vault)
		return <Loader />;

	const {
		nav,
		symbol,
		denomination: {
			label,
		},
	} = vault;

	const {
		draft,
		setDraftKey,
		getChangedPartial,
		keyIsDirty,
	} = useSharedDraftable<typeof nav>(nav, { emptyValues: true, instanceId: `${symbol}-vanity` });


	return (
		<Container>
			<Typography variant="paragraphXL" color="var(--text-heading-title)">
				Vanity NAV
			</Typography>

			<ContentContainer>
				<ItemContainer>
					<TitleContainer>
						<Typography variant="paragraphLG" color="var(--text-paragraph)">
							Current value
						</Typography>
						<Tooltip message="Last vanity NAV value updated for the vault" />
					</TitleContainer>

					<Typography variant="paragraphLG" color="var(--text-paragraph)">
						{vault.nav.nav.toString()}
					</Typography>
				</ItemContainer>

				<ItemContainer>
					<TitleContainer>
						<Typography variant="paragraphLG" color="var(--text-paragraph)">
							Last update
						</Typography>
						<Tooltip message="Date and time of the last Vanity NAV update for the vault" />
					</TitleContainer>
				</ItemContainer>

			</ContentContainer>

			<TextInput
				label="Set Vanity NAV"
				type="number"
				pattern="[0-9]*"
				onChange={value => setDraftKey("nav", value)}
				placeholder={`${label} value per share in WEI`}
				value={draft.nav.toString()}
				regex={/^[0-9]*$/}
			/>

			<ItemContainer>

				<TitleContainer>
					<Typography variant="paragraphLG" color="var(--text-paragraph)">
						Percentage Change
					</Typography>
					<Tooltip message="Percentage change from the last Vanity NAV value to the current Vanity NAV value" />
				</TitleContainer>

				<Typography variant="paragraphLG" color="var(--text-paragraph)">
					{ getPercChange("nav", draft, nav) }
				</Typography>
			</ItemContainer>

			<Button
				label="Update"
				variant="primary-outline"
				disabled={keyIsDirty("nav")}
				onClick={() => {
					const { nav, } = getChangedPartial();
					if(nav) {
						updateVanityNav(nav.toString());
					}
				}}
			/>

		</Container>
	);

};

const Container = styled.div`
	display: grid;
	padding: 24px;
	grid-template-rows: min-content min-content min-content 1fr min-content;
	gap: 32px;
	border-radius: 8px;
	background-color: var(--surface);
	box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const ContentContainer = styled.div`
	display: flex;
	gap: 32px;
`;

const ItemContainer = styled.div`
	display: flex;
	gap: 24px;
	flex-direction: column;
	flex: 1;
`;

const TitleContainer = styled.div`
	display: flex;
	gap: 4px;
	align-items: center;
	width: 100%;
`;
